export default __webpack_public_path__ + "static/egp3@2x-236be1b48394b945ad6f39337ad316ec.jpg";